// extracted by mini-css-extract-plugin
module.exports = {"twoSimplePieContainer":"TwoSimplePie_twoSimplePieContainer__1x37t"};